import { render, staticRenderFns } from "./ReferralEarningsPopup.vue?vue&type=template&id=3a665b78&scoped=true"
import script from "./ReferralEarningsPopup.vue?vue&type=script&lang=js"
export * from "./ReferralEarningsPopup.vue?vue&type=script&lang=js"
import style0 from "./ReferralEarningsPopup.vue?vue&type=style&index=0&id=3a665b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a665b78",
  null
  
)

export default component.exports